import { render, staticRenderFns } from "./TheHeaderButtonsMobile.vue?vue&type=template&id=06ffcb96"
import script from "./TheHeaderButtonsMobile.vue?vue&type=script&lang=js"
export * from "./TheHeaderButtonsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports